import React, { Component } from 'react';
import PropTypes from 'prop-types';
// @material-ui/icons
import image from 'assets/img/Logo.svg';
import Dehaze from '@material-ui/icons/Dehaze';
// @material-ui/core components
import { Hidden } from '@material-ui/core';
import Switch from '@material-ui/core/Switch';
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import Button from 'components/UI/CustomButtons/Button';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import Logged from 'components/Layout/Logged';
import styles, { NAV_BAR_HEIGHT } from 'assets/jss/Layout';

/**
 * @class
 * @extends Component
 */
class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
  }

  /**
   * @description
   * Handle show or hide menu
   */
  showMenu = () => {
    const { show } = this.state;
    this.setState({ show: !show });
  };

  /**
   * @description
   * Render menu items and Logged component
   */
  render() {
    const { menuIsOpen, showMenu, classes } = this.props;
    const { show } = this.state;
    return (
      <div
        className={classes.navContainer}
        style={{ maxHeight: show ? 240 : NAV_BAR_HEIGHT, overflow: 'hidden' }}
      >
        <GridContainer>
          <GridItem xs={12} sm={6} md={4}>
            <GridContainer justify="space-between">
              <GridItem>
                <div className={classes.logoSwitch}>
                  <span>
                    <img src={image} alt="Logo" className={classes.logo} />
                  </span>

                  <span>
                    <Switch
                      data-cy="showMenuButton"
                      id="showMenuButton"
                      key="sidebar-show-switch"
                      checked={menuIsOpen}
                      onChange={showMenu}
                      classes={{
                        checked: classes.switchChecked,
                        icon: classes.switchIcon,
                        iconChecked: classes.switchIconChecked,
                        bar: classes.switchBar,
                      }}
                    />
                  </span>
                </div>
              </GridItem>
              <GridItem>
                <Hidden smUp>
                  <Button
                    justIcon
                    simple
                    onClick={this.showMenu}
                    color="info"
                    className="update"
                  >
                    <Dehaze />
                  </Button>
                </Hidden>
              </GridItem>
            </GridContainer>
          </GridItem>

          <GridItem xs={12} sm={6} md={8}>
            <div
              className={[
                classes.profileDD,
                show ? classes.showProfileDD : '',
              ].join(' ')}
            >
              <Logged />
            </div>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

/**
 * Navbar PropTypes
 * @param classes - prop styles received from withStyles
 * @param menuIsOpen - prop to know if menu is show or hide
 * @callback showMenu - callback called when switch show or hide menu
 */

Navbar.propTypes = {
  menuIsOpen: PropTypes.bool.isRequired,
  showMenu: PropTypes.func.isRequired,
  classes: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(styles)(Navbar);
